import { usePlanCreatorContext } from "../PlanCreatorContext";
import cn from "classnames";
import styles from "./CalendarPeriods.module.scss";
import { ICalendarPeriodsProps } from "./CalendarPeriods.props";
import PeriodOptions from "./PeriodOptions/PeriodOptions";
import PeriodsTitle from "./PeriodsTitle/PeriodsTitle";
import { isEmptyPeriod } from "../Periods.utils";
import { IPlanRange } from "@services/getMinerList";



export default function CalendarPeriods(props: ICalendarPeriodsProps) {
  const { size = "m" } = props;

  const {
    addDefaultPeriod,
    removePeriodByIndex,
  } = usePlanCreatorContext();

  return (
    <div
      className={cn(styles.wrapper, {
        [styles.sizeSmall]: size === "s",
      })}
    >
      <PeriodsTitle />
      <div className={styles.values}>
        <PeriodOptions
          showSaveTemplate={props.showTemplates}
          onDeletePeriod={removePeriodByIndex}
          onAddPeriods={addDefaultPeriod}
        />
      </div>
    </div>
  );
}
